import {KtSetting, Template} from "../interfaces";


export const templates: Template[] = [];

function register(id: number, name: string, styles?: { [id: string]: any }) {
    templates.push({
        id: id,
        name: name,
        styles: styles
    });
}

register(1, 'classic 1');
register(2, 'mono 1', {
    text_color: '#ffffff',
    spacer_color: '#444444',
    background_color: '#000000'
});

